export const clientOrdersVisibleFields: IGlobalSurfaceKeyValue[] = [
	{ key: 'status', label: 'Status diety klienta', type: 'chip', icon: 'status' },
	{ key: 'createdAt', label: 'Data dodania', type: 'dateTime', icon: 'calendar' },
	{ key: 'dietName', label: 'Nazwa diety', type: 'text', icon: 'id-round' },
	{ key: 'daysLeftCount', label: 'Dni do końca', type: 'text', icon: 'calendar' },
	{ key: 'daysCount', label: 'Liczba dni zamów.', type: 'text', icon: 'calendar' },
]

export const clientOrdersDetailsVisibleFields: IGlobalSurfaceKeyValue[] = [
	{ key: 'status', label: 'Status diety klienta', type: 'chip', icon: 'status' },
	{ key: 'createdAt', label: 'Data dodania', type: 'dateTime', icon: 'calendar' },
	{ key: 'dietTypeLabel', label: 'Typ diety', type: 'text', icon: 'document' },
	{ key: 'dietName', label: 'Dieta', type: 'text', icon: 'diets' },
	{ key: 'daysCount', label: 'Liczba dni zamów.', type: 'text', icon: 'calendar' },
	{ key: 'daysLeftCount', label: 'Dni do końca', type: 'text', icon: 'calendar' },
	{ key: 'firstDietDay', label: 'Początek', type: 'date', icon: 'calendar2' },
	{ key: 'lastDietDay', label: 'Koniec', type: 'date', icon: 'calendar2' },
	{ key: 'lastDeliveryDate', label: 'Ostat. dost. paczk.', type: 'date', icon: 'calendar' },
]

export const clientOrdersAddressVisibleFields: IGlobalSurfaceKeyValue[] = [
	{ key: 'city', label: 'Miasto', type: 'text', icon: 'pin' },
	{ key: 'postcode', label: 'Kod pocztowy', type: 'text', icon: 'delivery-door' },
	{ key: 'district', label: 'Dzielnica', type: 'text', icon: 'blocks' },
	{ key: 'street', label: 'Ulica', type: 'text', icon: 'road' },
	{ key: 'buildingNumber', label: 'Numer budynku', type: 'text', icon: 'flag' },
	{ key: 'apartmentNumber', label: 'Numer lokalu', type: 'text', icon: 'flag' },
	{ key: 'staircase', label: 'Klatka', type: 'text', icon: 'flag' },
	{ key: 'floor', label: 'Piętro', type: 'text', icon: 'stairs' },
	{ key: 'deliveryPlaceLabel', label: 'Miejsce dostawy', type: 'text', icon: 'delivery-door' },
	{ key: 'entryCode', label: 'Kod klatki', type: 'text', icon: 'lock' },
	{ key: 'createdAt', label: 'Data dodania', type: 'dateTime', icon: 'calendar2' },
]

export const employeePaymentTypesFields: IGlobalSurfaceKeyValue[] = [
	{ key: 'newPricePerDay', label: 'Nowy koszt za dzień', type: 'price', icon: 'money' },
	{ key: 'priceToPay', label: 'Koszt do zapłaty', type: 'price', icon: 'money' },
	{ key: 'priceToRefund', label: 'Kwota do zwrotu', type: 'price', icon: 'money' },
]

export const clientDayDetailsVisibleFields: IGlobalSurfaceKeyValue[] = [
	{ key: 'status', label: 'Status diety klienta', type: 'chip', icon: 'status' },
	{ key: 'dietName', label: 'Nazwa diety', type: 'text', icon: 'diets' },
	{ key: 'createdAt', label: 'Data dodania', type: 'dateTime', icon: 'calendar' },
	{ key: 'daysCount', label: 'Liczba dni zamów.', type: 'text', icon: 'calendar' },
	{ key: 'daysLeftCount', label: 'Dni do końca', type: 'text', icon: 'calendar' },
	{ key: 'firstDietDay', label: 'Początek', type: 'date', icon: 'calendar2' },
	{ key: 'lastDietDay', label: 'Koniec', type: 'date', icon: 'calendar2' },
	{ key: 'lastDeliveryDate', label: 'Ostat. dost. paczk.', type: 'date', icon: 'calendar' },
	{ key: 'facilityName', label: 'Jednostka produkcyjna', type: 'text', icon: 'pin' },
]

export const kidsMenuMealSizeMap: Record<EMealType, number> = {
	[EMealType.BREAKFAST]: 2,
	[EMealType.SECOND_BREAKFAST]: 1,
	[EMealType.LUNCH]: 1,
	[EMealType.AFTERNOON_SNACK]: 1,
	[EMealType.DINNER]: 2,
	[EMealType.POST_WORKOUT]: 0,
}

export const foodpackMealSize = 3

export const clientOrderMealSizeMap: Record<number, Record<EMealType, number>> = {
	1000: {
		[EMealType.BREAKFAST]: 1,
		[EMealType.SECOND_BREAKFAST]: 1,
		[EMealType.LUNCH]: 1,
		[EMealType.AFTERNOON_SNACK]: 1,
		[EMealType.DINNER]: 1,
		[EMealType.POST_WORKOUT]: 1,
	},
	1200: {
		[EMealType.BREAKFAST]: 1,
		[EMealType.SECOND_BREAKFAST]: 2,
		[EMealType.LUNCH]: 1,
		[EMealType.AFTERNOON_SNACK]: 1,
		[EMealType.DINNER]: 1,
		[EMealType.POST_WORKOUT]: 1,
	},
	1350: {
		[EMealType.BREAKFAST]: 2,
		[EMealType.SECOND_BREAKFAST]: 1,
		[EMealType.LUNCH]: 1,
		[EMealType.AFTERNOON_SNACK]: 1,
		[EMealType.DINNER]: 1,
		[EMealType.POST_WORKOUT]: 1,
	},
	1500: {
		[EMealType.BREAKFAST]: 2,
		[EMealType.SECOND_BREAKFAST]: 2,
		[EMealType.LUNCH]: 1,
		[EMealType.AFTERNOON_SNACK]: 1,
		[EMealType.DINNER]: 1,
		[EMealType.POST_WORKOUT]: 1,
	},
	1550: {
		[EMealType.BREAKFAST]: 2,
		[EMealType.SECOND_BREAKFAST]: 2,
		[EMealType.LUNCH]: 1,
		[EMealType.AFTERNOON_SNACK]: 1,
		[EMealType.DINNER]: 1,
		[EMealType.POST_WORKOUT]: 1,
	},
	1750: {
		[EMealType.BREAKFAST]: 2,
		[EMealType.SECOND_BREAKFAST]: 2,
		[EMealType.LUNCH]: 2,
		[EMealType.AFTERNOON_SNACK]: 1,
		[EMealType.DINNER]: 1,
		[EMealType.POST_WORKOUT]: 1,
	},
	1800: {
		[EMealType.BREAKFAST]: 2,
		[EMealType.SECOND_BREAKFAST]: 2,
		[EMealType.LUNCH]: 2,
		[EMealType.AFTERNOON_SNACK]: 2,
		[EMealType.DINNER]: 1,
		[EMealType.POST_WORKOUT]: 1,
	},
	2000: {
		[EMealType.BREAKFAST]: 2,
		[EMealType.SECOND_BREAKFAST]: 3,
		[EMealType.LUNCH]: 2,
		[EMealType.AFTERNOON_SNACK]: 2,
		[EMealType.DINNER]: 1,
		[EMealType.POST_WORKOUT]: 1,
	},
	2200: {
		[EMealType.BREAKFAST]: 2,
		[EMealType.SECOND_BREAKFAST]: 3,
		[EMealType.LUNCH]: 3,
		[EMealType.AFTERNOON_SNACK]: 2,
		[EMealType.DINNER]: 1,
		[EMealType.POST_WORKOUT]: 1,
	},
	2500: {
		[EMealType.BREAKFAST]: 3,
		[EMealType.SECOND_BREAKFAST]: 3,
		[EMealType.LUNCH]: 3,
		[EMealType.AFTERNOON_SNACK]: 2,
		[EMealType.DINNER]: 1,
		[EMealType.POST_WORKOUT]: 1,
	},
	2800: {
		[EMealType.BREAKFAST]: 3,
		[EMealType.SECOND_BREAKFAST]: 3,
		[EMealType.LUNCH]: 3,
		[EMealType.AFTERNOON_SNACK]: 2,
		[EMealType.DINNER]: 2,
		[EMealType.POST_WORKOUT]: 2,
	},
	3000: {
		[EMealType.BREAKFAST]: 3,
		[EMealType.SECOND_BREAKFAST]: 4,
		[EMealType.LUNCH]: 3,
		[EMealType.AFTERNOON_SNACK]: 2,
		[EMealType.DINNER]: 2,
		[EMealType.POST_WORKOUT]: 2,
	},
	3200: {
		[EMealType.BREAKFAST]: 4,
		[EMealType.SECOND_BREAKFAST]: 4,
		[EMealType.LUNCH]: 3,
		[EMealType.AFTERNOON_SNACK]: 2,
		[EMealType.DINNER]: 2,
		[EMealType.POST_WORKOUT]: 2,
	},
	3500: {
		[EMealType.BREAKFAST]: 4,
		[EMealType.SECOND_BREAKFAST]: 4,
		[EMealType.LUNCH]: 4,
		[EMealType.AFTERNOON_SNACK]: 2,
		[EMealType.DINNER]: 2,
		[EMealType.POST_WORKOUT]: 2,
	},
	3800: {
		[EMealType.BREAKFAST]: 4,
		[EMealType.SECOND_BREAKFAST]: 4,
		[EMealType.LUNCH]: 4,
		[EMealType.AFTERNOON_SNACK]: 3,
		[EMealType.DINNER]: 2,
		[EMealType.POST_WORKOUT]: 2,
	},
	4000: {
		[EMealType.BREAKFAST]: 4,
		[EMealType.SECOND_BREAKFAST]: 4,
		[EMealType.LUNCH]: 4,
		[EMealType.AFTERNOON_SNACK]: 3,
		[EMealType.DINNER]: 3,
		[EMealType.POST_WORKOUT]: 3,
	},
}

export const clientCartsToPayVisibleFields: IGlobalSurfaceKeyValue[] = [
	{ key: 'priceToPay', label: 'Kwota do zapłaty', type: 'price', icon: 'money' },
	{ key: 'price', label: 'Wartość zamówienia', type: 'price', icon: 'money' },
	{ key: 'deliveryPrice', label: 'Koszt dostawy', type: 'price', icon: 'delivery' },
	{ key: 'originalPrice', label: 'Cena przed rabatem', type: 'price', icon: 'money' },
	{
		key: 'walletCashbackAmountReserved',
		label: clientWalletCoverageLabels[EWalletType.CASHBACK],
		type: 'price',
		icon: clientWalletCoverageIcons[EWalletType.CASHBACK],
	},
	{
		key: 'walletTopUpAmountReserved',
		label: clientWalletCoverageLabels[EWalletType.TOP_UP],
		type: 'price',
		icon: clientWalletCoverageIcons[EWalletType.TOP_UP],
	},
	{
		key: 'walletPromoAmountReserved',
		label: clientWalletCoverageLabels[EWalletType.PROMO],
		type: 'price',
		icon: clientWalletCoverageIcons[EWalletType.PROMO],
	},
	{ key: 'coupon.code', label: 'Kupon', type: 'text', icon: 'sale' },
	{ key: 'cartSource', label: 'Źródło', type: 'text', icon: 'flag' },
	{ key: 'createdAt', label: 'Data utworzenia', type: 'dateTime', icon: 'calendar' },
]

/** Stawka i próg darmowej dostawy jak w BE (`DeliveryCostThresholds`) - szacunek dostawy przed założeniem koszyka. */
export const BASE_DELIVERY_PRICE = 850
export const FREE_DELIVERY_THRESHOLD = 5200
